import xxHash from './xxHash';

/**
 * Create a hash string from any object, works for nested objects too
 * @param object Object to be hashed
 * @param seed Seed for hashing
 */
export default function hash(object: any, seed?: number) {
  // https://stackoverflow.com/a/53593328/91300
  // TODO: Possibly find solution to get properties recursively with better performance
  // However this is a widely supported method
  // and relatively clear to read and maintain (compared to others)
  const allKeys = [] as string[];
  JSON.stringify(object, (key, value) => { allKeys.push(key); return value; });
  allKeys.sort();
  return xxHash(JSON.stringify(object, allKeys, 0), seed);
}
